module.exports = __webpack_public_path__ + "img/10_uk.e27896e5.svg";